export default __webpack_public_path__ + "static/media/marker-sky-orange-yellow.a3ad68ee.png";